import styled from '@emotion/styled'

export const InstructionList = styled.ul`
  width: 912px;
  max-width: 100%;
  min-height: 160px;
  box-sizing: border-box;
  margin: 8px 0 28px;
  padding: 18px 24px 18px 40px;
  border-radius: 20px;
  background: #f2f6fa;
  font-size: 16px;
  line-height: 2;
  color: ${({ theme }) => theme.colors.main};

  li {
    margin-bottom: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: 767px) {
    min-height: auto;
    padding: 16px 18px 16px 32px;
    font-size: 14px;
    line-height: 1.6;
  }
`

export const QuestionsSection = styled.div`
  margin-top: 42px;
  display: flex;
  flex-direction: column;
  gap: 0;

  @media (max-width: 767px) {
    margin-top: 28px;
  }
`

export const QuestionsSectionTitle = styled.div`
  font-size: 28px;
  line-height: 34px;
  font-weight: 700;
  letter-spacing: 0;
  color: ${({ theme }) => theme.colors.text.black};
  margin-bottom: 26px;

  @media (max-width: 767px) {
    margin-bottom: 18px;
    font-size: 24px;
    line-height: 30px;
  }
`

export const QuestionsErrorText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.error};
  margin-top: 10px;
`

export const QuestionsEmptyPlaceholder = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.5;
  padding: 31px 24px;
  border-radius: 20px;
  background: #f2f6fa;
  margin-bottom: 24px;
`

export const QuestionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const QuestionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 52px;
  padding: 12px 14px;
  box-sizing: border-box;
  border-radius: 14px;
  background: #f2f6fa;

  @media (max-width: 767px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
    padding: 14px;
  }
`

export const QuestionText = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.black};
`

export const QuestionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  .ant-spin-nested-loading {
    width: auto;
  }

  button {
    min-width: 86px;
    width: auto !important;
    height: 31px;
    padding: 7px 13px;
    border-color: ${({ theme }) => theme.colors.main};
    font-size: 10px;
    line-height: 12px;
    color: ${({ theme }) => theme.colors.text.black};
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  button span {
    font-size: 10px;
  }

  button:hover {
    color: ${({ theme }) => theme.colors.text.black};
    background: transparent;
  }

  @media (max-width: 767px) {
    flex-wrap: wrap;
    width: 100%;

    .ant-spin-nested-loading,
    button {
      flex: 1 1 118px;
    }
  }
`

export const FinalTestFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 28px;

  > .ant-spin-nested-loading {
    width: auto;
  }

  && button {
    width: auto !important;
    min-width: 134px !important;
    max-width: none;
    justify-content: center;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 12px;

    > .ant-spin-nested-loading {
      width: 100%;
    }

    && button {
      width: 100% !important;
      min-width: 0 !important;
      max-width: none;
      white-space: normal;
    }
  }
`
